import SampleReportView from "@/components/samples/SampleReportView";
import { CORE_DEVELOPMENT_GROUP_REPORT } from "@/data/sample-reports";

const CoreDevelopmentGroupSample = () => <SampleReportView report={CORE_DEVELOPMENT_GROUP_REPORT} />;

export default CoreDevelopmentGroupSample;
